import { useState } from "react";

import { mapperResponseToList } from "mappers/mapperResponseToList";

import * as api from "../services/api";

export const useControlList = (handleShowError) => {
  const [list, setList] = useState([]);
  const [page, setPage] = useState(1);
  const [limit] = useState(8);
  const [haveMoreElemets, setHaveMoreElemets] = useState(false);

  const controlMetadata = (metadata) => {
    if (
      metadata.size === metadata.current &&
      metadata.page * metadata.size < metadata.total
    ) {
      setHaveMoreElemets(true);
    } else {
      setHaveMoreElemets(false);
    }
  };

  const handleLoadList = async (
    originURL,
    isShowroom,
    countryIso,
    languageIso,
    offset,
    limit,
    needRefresh,
    showDraft
  ) => {
    try {
      const response = await api.getList(
        originURL,
        isShowroom,
        countryIso,
        offset,
        limit,
        languageIso,
        showDraft
      );
      const newList = mapperResponseToList(response?.data?.content, showDraft);
      controlMetadata(response?.data?.metadata);
      if (needRefresh) {
        setList([...newList]);
      } else {
        setList([...list, ...newList]);
      }

      handleShowError(false);
    } catch (e) {
      setList([]);
      handleShowError(true);
    }
  };

  return {
    list,
    page,
    setPage,
    limit,
    haveMoreElemets,
    handleLoadList,
  };
};
